import { Component } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import TalaeraRoutes from "./../../../routes/TalaeraRoutes";

/**
 * This component redirects to a requested page after user is logged in. It redirects to `"/"` by default.
 */
export default class AuthRedirect extends Component {
  render() {
    const { pathname, hash } = this.props.location || {
      pathname: TalaeraRoutes.ROOT.path,
    };
    if (this.props.redirectToReferrer) {
      return <Navigate to={pathname + (hash || "")} replace />;
    }

    return <div>{this.props.children}</div>;
  }
}

AuthRedirect.propTypes = {
  /** A location object. */
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  /** A boolean value that indicates whether we need to redirect to any custom path or not. */
  redirectToReferrer: PropTypes.bool,
};
